@if (order$ | async; as order) {
  <div class="cx-order-items container">
    <!-- <h4 class="cx-order-items-header">
    {{ 'checkoutOrderConfirmation.orderItems' | cxTranslate }}
  </h4> -->
  <cx-promotions
    [promotions]="order.appliedOrderPromotions || []"
  ></cx-promotions>
  <!-- <ng-template
  [cxOutlet]="cartOutlets.CART_ITEM_LIST"
    [cxOutletContext]="{
      items: order.entries,
      readonly: true,
      promotionLocation: promotionLocation
    }"
  >
</ng-template> -->
@if(usj){
  <cx-cart-item-list [items]="order.entries!" [promotionLocation]="promotionLocation" [readonly]="true"  [displayProductUnitPrice]="true">
  </cx-cart-item-list>
}
@else if (ush || uhu) {
<cx-cart-item-list [items]="order.entries!" [promotionLocation]="promotionLocation" [readonly]="true" [displayProductUnitPrice]="true" [displayProductVariantTotalPrice]="true">
</cx-cart-item-list>
}
</div>
}
